import axios from 'axios';

export const getExams = async (contentListingId) => {
  const { data } = await axios.get(`/api/content-listings/${contentListingId}/exams`);
  return data;
};

export const createExam = async (form, contentListingId) => {
  const { data } = await axios.post(`/api/content-listings/${contentListingId}/exams`, form);
  return data;
};

export const updateExam = async (examId, form) => {
  const { data } = await axios.patch(`/api/exams/${examId}`, form);
  return data;
};

export const deleteExam = async (examId) => {
  const { data } = await axios.delete(`/api/exams/${examId}`);
  return data;
};

export const getExamQuestions = async (examId) => {
  const { data } = await axios.get(`/api/exams/${examId}/questions`);
  return data;
};

export const createExamQuestion = async (form, examId) => {
  const { data } = await axios.post(`/api/exams/${examId}/questions`, form);
  return data;
};

export const exportExamQuestions = async (examId) => {
  const response = await axios.get(`/api/exams/${examId}/questions/export`, {
    responseType: 'blob'
  });
  return response;
};

export const importExamQuestions = async (examId, file) => {
  const formData = new FormData();
  formData.append('file', file);
  const { data } = await axios.post(`/api/exams/${examId}/questions/import`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  });
  return data;
};

export const bulkUpdateExams = async (exams) => {
  // Use the new bulk update endpoint
  const { data } = await axios.patch('/api/exams/bulk-update', exams);
  return data;
};